module.exports = __webpack_public_path__ + "assets/webgl/FloorPattern.d8d3e690.jpg";